import baseTheme from '../baseTheme';
import colors from '../colors';
var MuiListItem = {
    /* your custom class style overrides here */
    container: {
        '& + &': {
            marginTop: baseTheme.spacing(1),
        },
    },
    root: {
        borderWidth: 1,
        '& + &': {
            marginTop: baseTheme.spacing(1),
        },
        '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected[class*=MuiButtonBase]:hover': {
            backgroundColor: 'rgba(3, 188, 235, 0.12)',
            border: "1px solid " + baseTheme.palette.grey[300],
        },
        '&.Mui-selected::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: '0',
            width: '2px',
            height: '100%',
            backgroundColor: colors.blue[500],
        },
        '&.Mui-selected$focusVisible, &.Mui-selected$focusVisible[class*=MuiButtonBase]': {
            backgroundColor: 'rgba(3, 188, 235, 0.2)',
        },
        '& [class*=MuiAvatar]': {
            padding: '0 0 0 0',
            backgroundColor: baseTheme.palette.grey[100],
            border: "1px solid " + baseTheme.palette.grey[300],
        },
        '&.Mui-selected [class*=MuiAvatar]': {
            border: "1px solid " + baseTheme.palette.primary.main,
            backgroundColor: 'transparent',
        },
        borderRadius: '4px',
        border: '1px solid transparent',
        overflow: 'hidden',
    },
    button: {
        '&:hover:not(.Mui-disabled), &[class*=MuiButtonBase]:hover:not(.Mui-disabled), &.Mui-focusVisible:not(.Mui-disabled)': {
            border: "1px solid " + baseTheme.palette.grey[300],
        },
    },
    disabled: {},
};
export default MuiListItem;
//# sourceMappingURL=MuiListItem.js.map